// extracted by mini-css-extract-plugin
module.exports = {"form_content":"FormContainer_form_content__U5lrr","form_footer":"FormContainer_form_footer__PoRso"};